import { Component } from '@angular/core';

@Component({
  selector: 'mz-dropdown-divider',
  template: `<li class="divider"></li>`,
  styles: [``],
})
export class MzDropdownDividerComponent { }
